import { getRequest, postRequest, getProposalID } from './api'

// id: the proposal the saga asked for (it compares the answer with it); default = the
// proposal on screen.
export async function list(id, unitType) {
  const proposalID = id || getProposalID()
  return getRequest(`proposalDetail/get-list/${proposalID}/${unitType}`)
}

export async function find(id) {
  return getRequest(`proposalDetail/edit/${id}`)
}

export async function save(values) {
  return postRequest(`proposalDetail/save`, values)
}

export function remove(values) {
  return postRequest(`proposalDetail/delete`, values)
}

export function getMaterial(id) {
  return getRequest(`proposalDetail/get-material/${id}`)
}

export async function saveMaterial(values) {
  return postRequest(`proposalDetail/save-material`, values)
}

export async function deleteMaterial(values) {
  return postRequest(`proposalDetail/delete-material`, values)
}
